import { POLL_IDLE_MS, POLL_MACHINE_MS, clampWhenHidden } from "@/lib/realtime";
import type { ReferenceSubmission } from "@/types/reference.type";

const TERMINAL: ReferenceSubmission["status"][] = ["completed", "failed"];

/**
 * Terminal is an allow-list, not `status === "processing"`: a state we don't
 * know about yet (a future "retrying") must keep polling rather than silently
 * freeze the activity indicator forever.
 */
export function isTerminalSubmission(submission: ReferenceSubmission): boolean {
  return TERMINAL.includes(submission.status);
}

/**
 * Never `false`: teammates paste into this same library, so the list keeps
 * refreshing at the idle floor even when nothing of ours is running.
 */
export function submissionsPollMs(submissions: ReferenceSubmission[] | undefined): number {
  const working = (submissions ?? []).some((s) => !isTerminalSubmission(s));
  return working ? POLL_MACHINE_MS : POLL_IDLE_MS;
}

export function submissionsRefetchInterval(
  submissions: ReferenceSubmission[] | undefined,
): number | false {
  return clampWhenHidden(submissionsPollMs(submissions));
}
